<template>
  <div class="topic_topic">
    <div class="topic-list" v-if="topList.length">
      <div v-for="(item,index) in topList"  @click="Linktopic(item.id)" :key="index" class="topic-list-one">
        <div class="topic-list-1">
          <span>#</span>
          <p> {{item.title}}</p>
          <div class="hot_new_tag hot" v-if="item.topic == 'RECOMMEND'">热</div>
          <!-- <div class="hot_new_tag new" v-else>新</div> -->
        </div>
        <p class="topic-list-tip van-ellipsis">{{item.summary}}</p>
      </div>
    </div>
    <div v-if="List&&List.length">
      <van-list
        class="ex_content"
        v-model="dataLoading"
        :finished="Finished"
        finished-text="It's the end~"
        @load="loadMore()"
      >
        <div class="supply_list_noissue">
          <div class="noissue_item"  @click="Linktopic(item.id)" v-for="(item,index) in List" :key="index">
            <!-- <img :src="item.logoUrl+oAvatarBig" v-if="item.logoUrl" > -->
            <img :src="item.logoUrl"  v-load="'oPic'" v-if="item.logoUrl">
            <img src="https://img.zhanshangxiu.com/showonline/file/202009/976f30b982904045aeec14be2bb0dea2.png"  v-else>
            <div class="noissue_info">
              <div class="info_title">#{{item.title}}#</div>
              <div class="info_brief">{{item.summary}}</div>
              <div class="info_count">
                <span>阅读数：{{item.viewCount}}</span>
                <span>讨论数：{{item.talkCount}}</span>
              </div>
              <div class="info_user" v-if="item.publisherType == 1">发起人：官方</div>
              <div class="info_user" v-else>发起人：{{item.publisherName}}</div>
            </div>
            <div class="like_btn " @click.stop="likeClick(item.id)" v-if="!item.isFollow">关注</div>
            <div class="like_btn cancel_btn" @click.stop="cancelLike(item.id)" v-else>已关注</div>
          </div>
        </div>
      </van-list>
    </div>
   <div class="no-msg" v-else>暂无数据！</div>
  </div>


</template>

<script>
  import { mapGetters, mapMutations, mapActions,mapState} from "vuex";
  import gql from 'graphql-tag'
  export default {
    name: "topic",
    data() {
      return {
        Finished: false, //供需加载是否完成状态
        List: [], //供需列表
        topList:[],
        pageSize: 12,
        pageIndex: 1,
        totalCount: 0,
        totalPages: 0,
        queryTheme:{
          items:{}
        },
        dataLoading: false, //数据加载状态
        dataFinished: false, //数据加载是否完成
      };
    },
    components: {},
    computed: {
      ...mapGetters({
        exhibitionId: "getExhibitionId",
        userInfo: "getUserInfo",
      }),
      ...mapState({
        oMyBus: "oMyBus",
        oAvatarBig:"oAvatarBig"
      }),
      ThemeGql(){
        return gql `query
                queryTheme(
                    $page: Int!
                    $size: Int!
                    $where: String!
                    $order: String){
                    queryTheme(query: { page: $page, size: $size, where: $where, order: $order } ){
                       hasNextPage
                       pageIndex
                       totalCount
                       items{
                        content
                        createAt
                        followCount
                        id
                        isDeleted
                        exhibitionId
                        isFollow(memberId: "${this.userInfo.id}")
                        logoUrl
                        memberId
                        publisherName
                        publisherType
                        shareCount
                        summary
                        talkCount
                        title
                        topic
                        topicIndex
                        userCount
                        viewCount
                       }
                    }
                }`
      },

    },
    created() {
      // this.getHotTopList();
      this.init();
    },
    methods: {
      ...mapMutations({
        setTopicTopicHeight: "setTopicTopicHeight",
      }),
      ...mapActions({
        getQueryTopic: "topicSupply/getQueryTopic",
        Linktopic:'linkTo/LinkToHotDetails',
        getTopic:'topicSupply/getTopic',
        followerTopic:'follower/followerTopic',
        delFollowerTopic:'follower/delFollowerTopic'
      }),
      getCount(val){
        let value=val;
        let num;
        if (value > 9999) { //大于9999显示x.xx万
            num = (Math.floor(value / 100) / 100) + 'w';
        } else if (value <= 9999 && value > -9999) {
            num = value
        } else if (value < -9999) { //小于-9999显示-x.xx万
            num = -(Math.floor(Math.abs(value) / 1000) / 10) + 'w'
        }
        return num;
      },
      init() {
        this.getHotList();
        this.getHotTopList();
      },
      getHotTopList(){
        let where = {
            "Equal":{
              "n":"isDeleted",
              "v":0
            },
            "Equal2":{
              "n":"exhibitionId",
              "v":this.exhibitionId
            },
            "GreaterThan":{
              "n":"topic",
              "v":0
            },
        };
        let order = [
          {
            "n":"viewCount",
            "v":0
          },
        ];
        this.$apollo.addSmartQuery("queryTheme",{
          query:this.ThemeGql,
          variables:{
            page: this.pageIndex,
            size: this.pageSize,
            where:JSON.stringify(where),
            order:JSON.stringify(order),
          },
          fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
          result(data){
            if(data&&data.data.queryTheme.items.length){
              this.topList=[...data.data.queryTheme.items];
            }
            this.$nextTick(()=>{
              $('html , body').animate({scrollTop: 1},0,()=>{
                $('html , body').stop().animate({scrollTop: 0},0);
              });
            })
          }
        })
      },
      getHotList(){
         let where = {
            "Equal":{
              "n":"isDeleted",
              "v":0
            },
            "Equal2":{
              "n":"exhibitionId",
              "v":this.exhibitionId
            },
        };
        let order = [
          {
            "n":"viewCount",
            "v":0
          },
          {
            "n":"createAt",
            "v":0
          },
        ];
        this.$apollo.addSmartQuery("queryTheme",{
          query:this.ThemeGql,
          variables:{
            page: this.pageIndex,
            size: this.pageSize,
            where:JSON.stringify(where),
            order:JSON.stringify(order),
          },
          fetchPolicy:'no-cache',  // 清除缓存的数据，重新获取服务器数据
          result(data){
            if(data&&data.data.queryTheme.items.length){
              let currentList = data.data.queryTheme.items;
              if(this.pageIndex == 1){
                this.List = currentList;
              } else {
                this.List = [...this.List,...currentList]
              }
              this.dataLoading = false;
              if (!data.data.queryTheme.hasNextPage) {
                this.Finished = true;
              }
              console.log(this.List,'this.List')
              // data.data.queryTheme.items.forEach(el => {
              //   if(el.viewCount>=10000){
              //     el.viewCount=this.getCount(el.viewCount);
              //   }
              //   if(el.talkCount>=10000){
              //     el.talkCount=this.getCount(el.talkCount);
              //   }
              // });
              // this.List=[...this.List,...data.data.queryTheme.items];

              // this.dataLoading = false;
              // this.hasNextPage = data.data.queryTheme.hasNextPage;
              // if (!data.data.queryTheme.hasNextPage) {
              //   this.Finished=true
              // }
              // console.log( this.pageIndex,'this.List')
            }
          }
        })
      },
      //关注
      async likeClick(id){
        let user={
          name:this.userInfo.name,
          nickName:this.userInfo.nickName,
          avatarUrl:this.userInfo.avatarUrl,
          jobTitle:this.userInfo.jobTitle
        }
        let opt={
          themeId:id,
          memberId:this.userInfo.id,
          userInfo:JSON.stringify(user)
        };
        let res= await this.followerTopic(opt);
        if(res.result){
          this.$toast.success('已关注 ');
          if(id){
            this.List.map(c=>{
              if(id === c.id){
                c.isFollow = true;
              }
            })
          }
        }else{
          this.$toast.fail('关注失败 ');
        }
      },
      //取消关注
      async cancelLike(id){
        let opt={
          themeId:id,
          memberId:this.userInfo.id
        }
        let res=await this.delFollowerTopic(opt);
        if(res.result){
          this.$toast.success('取消关注 ');
          if(id){
            this.List.map(c=>{
              if(id === c.id){
                c.isFollow = false;
              }
            })
          }
        }else{
          this.$toast.fail('取消失败 ');
        }
      },
      loadMore() {
        if (this.Finished) return;
        this.pageIndex += 1;
        console.log(this.pageIndex ,'当前请求的页码')
        this.getHotList();
      },
    }
  };
</script>

<style scoped lang="scss">
.topic_topic{
  .topic-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: #fff;
    border-radius: 5px;
    padding:.34rem .26rem .26rem;
    margin:.3rem;
    .topic-list-one {
      width: 48%;
      height: .9rem;
      font-size: .24rem;
      .topic-list-1 {
        display: flex;
        align-items: center;
        span {
          font-size: .3rem;
          color: #f85a10;
          margin-right: .1rem;
        }
        .hot_new_tag {
          flex-shrink: 0;
          width: .3rem;
          height: .3rem;
          border-radius: .15rem .15rem .15rem 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: .18rem;
          margin-left: .1rem;
          color: #fff;
          &.hot{
            background: #f85a10;
          }
          &.new{
            background: #1890ff;
          }
        }
        p {
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          font-weight: bold;
        }
      }
      .topic-list-tip{
        font-size:.2rem;
        color:#666666;
        margin: .04rem 0 0 .26rem;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
  }

  .supply_list_noissue{
    .noissue_item{
      height: 2rem;
      box-sizing: border-box;
      padding: .2rem;
      background-color: #fff;
	  border-radius: 3px;
      display: flex;
      margin: .3rem;
      position: relative;
      .like_btn{
        position: absolute;
        bottom: .2rem;
        right: .2rem;
        height: .48rem;
        width: 1.2rem;
        border-radius: 13px;
        background: #ff5c00;
        color: #fff;
        font-size: .24rem;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        &.cancel_btn{
          border: solid 1px #ff5c00;
          color: #ff5c00;
          background: transparent;
        }
      }
      &:last-child{
        margin-bottom: 0;
      }
      img{
        flex-shrink: 0;
        width: 1.6rem;
        height: 1.6rem;
        border-radius: .05rem;
        display: block;
      }
      .noissue_info{
        width: calc(100% - 1.8rem);
        margin-left: .2rem;
        color: #666;
        font-size: .2rem;
        display: flex;
        flex-direction: column;
        div{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .info_title{
          font-size: .26rem;
          color: #333;
          font-weight: 600;
        }
        .info_brief{
          margin-top: .05rem;
          font-size: .2rem;
        }
        .info_count{
          margin-top: .2rem;
          span{
            margin-right: .3rem;
            font-size: .2rem;
            &:last-child{
              margin-right: 0;
            }
          }
        }
        .info_count,.info_user{
          max-width: calc(100% - 1.2rem);
        }
        .info_user{
          margin-top: auto;
          font-size: .24rem;
          color: #333;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
